async function getPaymentSchedules(jsonObj) {
	let response = await fetch(
		process.env.REACT_APP_GENERATE_PAYMENT_SCHEDULE_URL,
		{
			method: 'POST',
			credentials: 'include',
			headers: {
				RateImplicitApiKey: process.env.REACT_APP_RATE_IMPLICIT_API_KEY,
				Accept: 'application/json',
				'Content-Type': 'application/json; charset=utf-8',
			},
			body: JSON.stringify(jsonObj),
		}
	).catch((err) => console.log(err))

	if (response === undefined) {
		return 'error'
	}

	if (response.status === 200) {
		let data = await response.json()
		return data
	}

	return 'error'
}

async function getRateImplicit(jsonObj) {
	let response = await fetch(process.env.REACT_APP_GET_RATE_URL, {
		method: 'POST',
		credentials: 'include',
		headers: {
			RateImplicitApiKey: process.env.REACT_APP_RATE_IMPLICIT_API_KEY,
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8',
		},
		body: JSON.stringify(jsonObj),
	}).catch((err) => console.log(err))
	let data = await response.json()
	return data
}

export { getPaymentSchedules, getRateImplicit }
